<template>
    <expo-matching-state
        v-bind="{
            value,
            program,
            employee,
            employer,
            isUserHost,
            isUserEmployee,
            isUserEmployer,
        }"
        @input="pushMatchings"
    />
</template>

<script>
import { initExpoEmployer, initExpoProgram } from "@/assets/variables";

import ExpoMatchingState from "@/components/client/expo/matching/expo-matching-state.vue";
import { mapMutations, mapState } from "vuex";

export default {
    components: {
        ExpoMatchingState,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
        employer: { type: Object, default: initExpoEmployer },
        isUserHost: { type: Boolean, default: false },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    computed: {
        ...mapState("expo", ["employee", "matchings"]),

        value() {
            return this.matchings.find(({ _employer }) => _employer == this.employer._id);
        },
    },
    methods: {
        ...mapMutations("expo", ["pushMatchings"]),
    },
};
</script>

<style>
</style>